import React from "react";
import { AlertList } from "react-bs-notifier";

const alerts = [
    {
        id: 1,
        type: "success",
        message: "נשמר בהצלחה"
    },
    {
        id: 2,
        type: "danger",
        message: "שגיאה בשמירה"
    }
];

class Notifier extends React.Component {
    constructor(props) {
        super(props);
        this.state = { alerts: [] };
    }

    showSuccess(message) {
        const alert = message ? { id: 1, type: "success", message } : alerts[0];
        this.setState({
            alerts: [...this.state.alerts, alert]
        });
    }

    showError(message) {
        const alert = message ? { id: 2, type: "danger", message } : alerts[1];
        this.setState({
            alerts: [...this.state.alerts, alert]
        });
    }

    onAlertDismissed = (alert) => {
        const alerts = this.state.alerts;
        // find the index of the alert that was dismissed
        const idx = alerts.indexOf(alert);

        if (idx >= 0) {
            this.setState({
                // remove the alert from the array
                alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
            });
        }
    };

    render() {
        return (
            <AlertList
                onDismiss={this.onAlertDismissed}
                alerts={this.state.alerts}
                position="bottom-right"
                timeout={1500}
            />
        );
    }
}

export default Notifier;
